<template>
    <div>
      <modal size="medium">
          <div slot="header" class>Modifier le commentaire</div>
          <div slot="body">
              <p id="temContent" v-html="content"></p>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2 validate" @click="$emit('confirm')">Valider</button>
              </div>
              </br>
          </div>
      </modal>
    </div>
</template>

<script>
import modal from './modal.vue'

export default {
  name: 'textEditModal',
  components: {
    modal
  },
  props: {
    'content': null
  },
  mounted () {
    if (!window.CKEDITOR) {
      console.error('Please include CKEditor in your page')
      return
    }
    window.CKEDITOR.replace('temContent')
    window.CKEDITOR.instances.temContent.setData(this.content)
  },
  methods: {
    getText () {
      return window.CKEDITOR.instances.temContent.getData()
    }
  },
  data () {
    return {
      showModal: false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// text-edit-modal.vue?6f40c736